import { translate } from "../../../util/translate"

export const vendorsHeader = [
  {
    text: translate['vendors.label.name'],
    value: 'name',
    width: 400,
  },
  {
    text: translate['vendors.label.document'],
    value: 'document',
    width: 200,
  },
  {
    text: translate['vendors.label.createdAt'],
    value: 'date_created',
    width: 130,
  },
  { value: 'actions', align: 'end', width: 320 },
]
